import { render, staticRenderFns } from "./OrganizationHealthCard.vue?vue&type=template&id=50b31f48&scoped=true"
import script from "./OrganizationHealthCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationHealthCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationHealthCard.vue?vue&type=style&index=0&id=50b31f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b31f48",
  null
  
)

export default component.exports